import { Theme, ThemeOptions, alpha } from '@mui/material';
import _ from 'lodash';
import { colors } from './colors';

export const BoxShadows = {
  btnFocus: `0 0 0 2px ${colors.common.black}, inset 0 0 0 2px ${colors.common.white}`,
};

export const shadowStyles = (theme: Theme): ThemeOptions => ({
  shadows: ((): ThemeOptions['shadows'] => {
    const shadows = _.clone(theme.shadows);
    shadows[10] = `0 0.25rem 1.25rem ${alpha(theme.palette.secondary.main, 0.1)}`;
    shadows[15] = `0 0.25rem 1.25rem ${alpha(theme.palette.secondary.main, 0.25)}`;
    return shadows;
  })(),
});
